/* eslint-disable */
// import { authHeader } from '../_helpers';
import { frenapi as api } from '../main'
import { Capacitor } from "@capacitor/core"


export const userService = {
    login,
    logout,
    getAll,
    getRole,
};


async function login(username, password) {
const params = {
  username: username, //gave the values directly for testing
  password: password,
  scope: "repairs customers suppliers quotes me income inventory",
  client_id: Capacitor.isNative ? "frena-android" : "frena-app"
};

const data = Object.keys(params)
  .map((key) => `${key}=${encodeURIComponent(params[key])}`)
  .join('&');
  
const options = {
  method: 'POST',
  headers: { 'content-type': 'application/x-www-form-urlencoded' },
  data,
  url: '/users/token'
};
const user = await api(options)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user.access_token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
            }

            return user;
        });

const info = await api.get("/users/me/")
    .then(handleResponse)
    .then(info => {
        localStorage.setItem('userInfo', JSON.stringify(info));
        return info
    });

return user;
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
    localStorage.removeItem('userInfo');
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return api('/customers', requestOptions).then(handleResponse);
}


function getRole() {
    return api.get('/users/me').then(response => {
    return response.data.Role;
    });
}

function handleResponse(response) {
        const data = response.data;
        console.log(response)
        if (response.status != 200) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
}
